// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1xzgs","containerItemsCenter":"Skeleton_containerItemsCenter__2OvWh"};